import { create } from "zustand";

interface SocketState {
  socket: WebSocket | null;
  setSocket: (s: WebSocket | null) => void;
}

export const useSocketStore = create<SocketState>((set) => ({
  socket: null,
  setSocket: (s) => set({ socket: s }),
}));